// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-192b7c6d] .el-tabs__item.is-active{color:#fff!important;font-size:1.04167vw!important}[data-v-192b7c6d] .el-tabs__active-bar{display:none}[data-v-192b7c6d] .el-tabs__nav{line-height:2.60417vw}", ""]);
// Exports
module.exports = exports;
